{
  "title": "Asukassivut",
  "heading": "Kirjaudu sisään",
  "username": "Sähköposti",
  "password": "Salasana",
  "error": "Virhe kirjautumisessa",
  "submit": "Kirjaudu sisään",
  "forgotPasswordButtonText": "Salasana unohtunut?",
  "errors": {
    "loginExpired": "Kirjautuminen on vanhentunut. Ole hyvä ja kirjaudu uudelleen sisään.",
    "userAlreadyRegistered": "Tunnistettuun käyttäjään on jo kytketty käyttäjätunnus {{email}}. Voit palauttaa salasanan Salasana unohtunut -toiminnolla.",
    "noTenantFound": "Tunnistetun käyttäjän tiedoilla ei löydy yhtään sopimusta."
  }
}
